import React from 'react';
import './LuckyBalls.css';

const LuckyBalls = ({ luckyNumbers, onBallClick, progress }) => {
  const totalBalls = 7;
  const shouldBlink = progress >= 0 && progress <= 47;

  return (
    <div className="lucky-balls-container">
      <h2 className="section-title">幸运数字序列</h2>
      <div className="lucky-balls-grid">
        {Array.from({ length: totalBalls }, (_, index) => {
          const luckyData = luckyNumbers[index];
          const status = luckyData?.status || 'pending';
          const number = luckyData?.number;
          const ballColor = index < 6 ? 'red' : 'blue';
          const blinkClass = (status === 'generating' && shouldBlink) ? 'blink' : '';

          return (
            <div
              key={index}
              className={`lucky-ball ${status} ${ballColor} ${blinkClass}`}
              onClick={() => status === 'completed' && onBallClick(index, luckyData)}
              style={{ cursor: status === 'completed' ? 'pointer' : 'default' }}
            >
              {status === 'completed' && number !== undefined ? (
                <span className="ball-number">{number}</span>
              ) : status === 'generating' ? (
                <span className="ball-placeholder">?</span>
              ) : (
                <span className="ball-empty"></span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LuckyBalls;
